import { Snackbar } from '@material-ui/core';
import Alert from '@material-ui/lab/Alert';
const SnackbarAlert = ({ openAlert, text, onClose, type }) => {
  return (
    <Snackbar
      open={openAlert}
      anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      autoHideDuration={6000}
      onClose={() => {
        onClose();
      }}
    >
      <Alert
        elevation={6}
        variant="filled"
        onClose={() => {
          onClose();
        }}
        severity={type}
      >
        {text}
      </Alert>
    </Snackbar>
  );
};
export default SnackbarAlert;
